const defaultState = {
  report: {},
  error: null,
  fetching: false,
  fetched: false
};

const getTheftReportReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'THEFT_REPORT_CLEAR': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: null
      };
    }
    case 'THEFT_REPORT_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true, report: {}
      };
    }
    case 'THEFT_REPORT_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: action.payload.data
      };
    }
    case 'THEFT_REPORT_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        report: {},
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default getTheftReportReducer;


// WEBPACK FOOTER //
// ./src/reducers/getTheftReport.js